/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */

import { faEye, faListOl, faVideo } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment-timezone';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Filter } from 'react-table';
import { Dispatch } from 'redux';
import { EventState, UserViewModel, EventViewModel } from 'stageclip-common';

import { createEventsStatisticsRequestedAction } from '../../actions/eventStatisticsActions';
import { createAssignEventRequestAction } from '../../actions/eventActions';
import * as DateHelpers from '../../helpers/dateHelpers';
import * as PermissionsHelper from '../../helpers/permissionsHelper';
import * as UserHelper from '../../helpers/userHelper';
import { NormalizedClient } from '../../models/normalized/normalizedClient';
import { NormalizedEvent } from '../../models/normalized/normalizedEvent';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import { ById } from '../../store/normalizedState';
import Button from '../buttons/button';
import {
  BaseDispatchProps,
  baseMapDispatchToProps,
  baseMapStateToProps,
  BaseStateProps,
  ComponentBase,
} from '../componentBase';
import { ClientUserTimezonesDate } from '../date/clientUserTimezonesDate';
import { DateTimeRangeSelector } from '../date/dateTimeRangeSelector';
import { AppTableClippingQueue, AppTableColumn } from '../table/appTableClippingQueue';
import Icon from '../utils/icon';

// import { ArchiveEventModal } from './archiveEventModal/ArchiveEventModal';
import { createModalOpenAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';
import styles from './eventsTable.module.scss';

export enum EventsTableClippingColumns {
  ClientName = 'clientName',
  EventName = 'eventName',
  EventType = 'eventType',
  EventStart = 'eventStart',
  EventReadyEstimate = 'eventReadyEstimate',
  Assignee = 'assignee',
  Status = 'status',
  TotalParticipants = 'totalParticipants',
  ParticipantsWithClipsGenerated = 'participantsWithClipsGenerated',
  ClipGenerationErrors = 'clipGenerationErrors',
  TotalClipsProcessing = 'totalClipsCurrentlyProcessing',
  TotalClipsPending = 'totalClipsPending',
  TotalClipsWaitingForData = 'totalParticipantsWaitingForData',
  ViewButton = 'viewButton',
  Actions = 'actions',
  NoOfParticipants = 'noOfParticipants',
  NoOfParticipantsWithUploadedData = 'noOfParticipantsWithUploadedData',
  NoOfParticipantsWithUploadedDataInSubmittedState = 'noOfParticipantsWithUploadedDataInSubmittedState',
  NoOfParticipantsWithUploadedDataInAcceptedState = 'noOfParticipantsWithUploadedDataInAcceptedState',
  NoOfParticipantsInRejectedState = 'noOfParticipantsInRejectedState',
}

const fixedColumns = [EventsTableClippingColumns.Actions];

interface EventsTableOwnProps {
  columns?: EventsTableClippingColumns[];
  archived?: boolean;
  onFilterChange?: (filteredRows: any[], allRows: any[]) => void;
  getStatistics?: boolean;
}
interface EventsTableStateProps extends BaseStateProps {
  clients?: ById<NormalizedClient>;
  allEventsLoaded?: boolean;
  events?: NormalizedEvent[];
  users: ById<UserViewModel>;
}

interface EventsTableDispatchProps extends BaseDispatchProps {
  assignEvent: (c: EventsTableClippingPresentation, eventId: string, userId: string) => void;
  loadAllEvents?: (c: EventsTableClippingPresentation) => void;
  loadEventsStats: (eventIds: string[], c: EventsTableClippingPresentation) => void;
  openArchiveEventModal: (event: EventViewModel) => void;
}
interface EventsTableState {
  lastLoadedStats: moment.Moment;
}

const defaultFiltered = [
  {
    id: EventsTableClippingColumns.EventStart,
    value: {
      endDate: moment().add(14, 'days'),
      startDate: moment().subtract(14, 'days'),
    },
  },
  {
    id: EventsTableClippingColumns.Status,
    value: EventState.ReadyToClip,
  },
];

export class EventsTableClippingPresentation extends ComponentBase<
  EventsTableOwnProps,
  EventsTableStateProps,
  EventsTableDispatchProps,
  EventsTableState
> {
  constructor(props: any) {
    super(props);
    this.assignEventToCurrentUser = this.assignEventToCurrentUser.bind(this);
    this.displayEventStats();
    this.state = {
      lastLoadedStats: undefined,
    };
  }

  private static renderState(value: any, className: string) {
    return (
      <>
        <span className={className}>{value}</span>
      </>
    );
  }

  protected tableRef = React.createRef<any>();

  private static getStateCell(row: any) {
    switch (row.value) {
      case EventState.WaitingForAssets:
        return EventsTableClippingPresentation.renderState(
          <>
            Waiting&nbsp;&nbsp;
            {row.original.totalNoOfParticipants === 0 && <Icon icon={faListOl} noMargins transparent />}
            {row.original.totalNoOfEventVideos === 0 && <Icon icon={faVideo} noMargins transparent />}
          </>,
          styles.waitingAssetsState,
        );
      case EventState.ReadyToClip:
        return EventsTableClippingPresentation.renderState('Ready', styles.readyToClipState);
      default:
        return EventsTableClippingPresentation.renderState(row.value, styles.state);
    }
  }

  private timer: any;

  private idsOfVisibleEvents: string[];

  private columns: AppTableColumn[] = [
    {
      Header: 'Event Data',
      columns: [
        {
          Header: 'Client',
          accessor: (event: NormalizedEvent) => event.client.name,
          className: 'break-words',
          dropdownFilter: true,
          id: EventsTableClippingColumns.ClientName,
          width: 290,
        },
        {
          Cell: (row: any) => <Link to={`/events/${row.original.id}`}>{row.value || 'No Name (View)'}</Link>,
          Header: 'Event Name',
          accessor: (event: NormalizedEvent) => event.name,
          className: 'emphasize break-words',
          dropdownFilter: true,
          id: EventsTableClippingColumns.EventName,
          width: 250,
        },
        {
          Header: 'Event Type',
          accessor: (event: NormalizedEvent) => event.name,
          className: 'break-words',
          dropdownFilter: true,
          id: EventsTableClippingColumns.EventType,
          width: 120,
        },
        {
          Cell: (row: any) => (
            <ClientUserTimezonesDate
              date={row.value}
              timezone={row.original.timezone || row.original.client.timezone}
            />
          ),
          Filter: ({ onChange, filter: { value } }: any) => (
            <DateTimeRangeSelector startDate={value.startDate} endDate={value.endDate} onChange={onChange} />
          ),
          Header: 'Event Start',
          accessor: (event: NormalizedEvent) => DateHelpers.sortableDateFormat(event.startTime),
          filterMethod: (filter: Filter, row: any) => {
            const eventStart = moment(row.eventStart).tz(moment.tz.guess());

            return (
              (!filter.value.startDate || eventStart.isSameOrAfter(filter.value.startDate)) &&
              (!filter.value.endDate || eventStart.isSameOrBefore(filter.value.endDate))
            );
          },
          filterable: true,
          id: EventsTableClippingColumns.EventStart,
          width: 230,
        },
        {
          Header: 'Assigned To',
          accessor: (event: NormalizedEvent) =>
            event.assignee ? UserHelper.userFullName(this.props.users[event.assignee]) : 'Unassigned',
          className: 'break-words',
          dropdownFilter: false,
          id: EventsTableClippingColumns.Assignee,
          width: 100,
        },
        {
          Cell: EventsTableClippingPresentation.getStateCell,
          Header: 'Status',
          accessor: (event: NormalizedEvent) => event.state,
          dropdownFilter: false,
          id: EventsTableClippingColumns.Status,
          width: 150,
        },
      ],
    },
    {
      Cell: ({ original: { id, state } }) =>
        state !== EventState.Complete && (
          <Button text="Assign to me" icon={faEye} onClick={() => this.assignEventToCurrentUser(id)} />
        ),
      Header: 'Actions',
      accessor: (event: NormalizedEvent) => event.id,
      className: styles.actions,
      id: 'actions',
    },
  ];

  // eslint-disable-next-line camelcase
  public async UNSAFE_componentWillMount() {
    if (super.UNSAFE_componentWillMount) {
      await super.UNSAFE_componentWillMount();
    }
  }

  public async componentDidMount() {
    if (super.componentDidMount) {
      await super.componentDidMount();
    }

    await this.getStatistics();

    if (this.props.getStatistics) {
      this.timer = setInterval(this.getStatistics, 30000);
    }
  }

  public async componentWillUnmount() {
    if (super.componentWillUnmount) {
      await super.componentWillUnmount();
    }
    clearInterval(this.timer);
    this.timer = null;
  }

  protected dataLoaded(props: any) {
    return props.allEventsLoaded;
  }

  protected async loadData(props: any) {
    if (!props.allEventsLoaded) {
      await props.loadAllEvents(this);
    }
  }

  protected loggedInRender() {
    const rowProps = (state: any, rowInfo: any) => ({
      className: new Date(rowInfo.original.startTime) > new Date() ? styles.futureEventRow : '',
    });

    const noDataProps = () => ({
      className: styles.noData,
    });

    return (
      <div>
        <AppTableClippingQueue
          ref={this.tableRef}
          columns={this.filterColumnsForDisplay()}
          data={this.props.events}
          tableName="events"
          defaultFiltered={defaultFiltered}
          defaultSorted={[{ id: 'eventStart', desc: false }]}
          className="with-header-groups"
          noDataText="No data to display - maybe data is filtered out?"
          getNoDataProps={noDataProps}
          defaultPageSize={10}
          onFilterChange={this.handleFilterChange}
          tableHeaderChildren={
            this.props.getStatistics &&
            this.state.lastLoadedStats && (
              <span>Stats last refreshed at {this.state.lastLoadedStats.format('DD-MM-YYYY HH:mm:ss')}</span>
            )
          }
          getTrProps={rowProps}
          //  id={`events_${this.props.archived ? 'archived' : 'active'}_table`}
          cacheFilters={[EventsTableClippingColumns.EventStart]}
        />
        {/* <ArchiveEventModal /> */}
      </div>
    );
  }

  private displayEventStats() {
    function getEventStatistics(event: NormalizedEvent, data: any) {
      const statisticsLoaded = event.totalParticipants !== undefined;

      return statisticsLoaded ? data || 0 : '-';
    }

    if (PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.ViewEventStatistics)) {
      this.columns.splice(-1, 0, {
        Header: 'Participants Stats',
        columns: [
          {
            Cell: (row: any) => getEventStatistics(row.original, row.value),
            Header: 'Total',
            accessor: (event: NormalizedEvent) => event.totalParticipants,
            className: 'left-border',
            id: EventsTableClippingColumns.TotalParticipants,
            width: 60,
          },
          {
            Cell: (row: any) => getEventStatistics(row.original, row.value),
            Header: 'Generated',
            accessor: (event: NormalizedEvent) => event.totalClipsGenerated,
            id: EventsTableClippingColumns.ParticipantsWithClipsGenerated,
            width: 80,
          },
          {
            Cell: (row: any) => getEventStatistics(row.original, row.value),
            Header: 'Processing',
            accessor: (event: NormalizedEvent) => event.totalClipsProcessing,
            id: EventsTableClippingColumns.TotalClipsProcessing,
            width: 80,
          },
          {
            Cell: (row: any) => getEventStatistics(row.original, row.value),
            Header: 'Pending',
            accessor: (event: NormalizedEvent) => event.totalClipsPending,
            id: EventsTableClippingColumns.TotalClipsPending,
            width: 70,
          },
          {
            Cell: (row: any) => getEventStatistics(row.original, row.value),
            Header: 'Waiting data',
            accessor: (event: NormalizedEvent) => event.totalClipsWithoutData,
            id: EventsTableClippingColumns.TotalClipsWaitingForData,
            width: 80,
          },
          {
            Cell: (row: any) => getEventStatistics(row.original, row.value),
            Header: 'Errors',
            accessor: (event: NormalizedEvent) => event.totalClipErrors,
            id: EventsTableClippingColumns.ClipGenerationErrors,
            width: 60,
          },
        ],
      });
    }
  }

  private getStatistics = async () => {
    if (PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.ViewEventStatistics)) {
      await this.props.loadEventsStats(this.idsOfVisibleEvents, this);
      this.setState({ ...this.state, lastLoadedStats: moment() });
    }
  };

  private handleFilterChange = (filteredRows: any[], allRows: any[]) => {
    // eslint-disable-next-line no-underscore-dangle
    this.idsOfVisibleEvents = filteredRows.map(r => r._original.id);

    if (this.props.onFilterChange) {
      this.props.onFilterChange(filteredRows, allRows);
    }
  };

  private hasColumn(column: EventsTableClippingColumns): boolean {
    if (!this.props.columns) {
      return true;
    }

    return this.props.columns.concat(fixedColumns).indexOf(column) >= 0;
  }

  private filterColumnsForDisplay(columns: AppTableColumn[] = this.columns): AppTableColumn[] {
    if (!this.props.columns) {
      return columns;
    }

    return columns.reduce((result, c) => {
      if (c.columns) {
        if (c.columns.length === 0) {
          return result;
        }

        return result.concat({ ...c, columns: this.filterColumnsForDisplay(c.columns) });
      }

      return this.hasColumn(c.id as EventsTableClippingColumns) ? result.concat(c) : result;
    }, []);
  }

  private assignEventToCurrentUser(eventId: any) {
    this.props.assignEvent(this, eventId, this.props.currentUser.id);
  }
}

function mapStateToProps(state: ClippingPlatformState): EventsTableStateProps {
  return {
    ...baseMapStateToProps(state),
    users: state.entities.users.byId,
  };
}

function mapDispatchToProps(dispatch: Dispatch): EventsTableDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    assignEvent: (c: EventsTableClippingPresentation, eventId: string, userId: string) =>
      dispatch(createAssignEventRequestAction(eventId, userId, c, dispatch)),
    loadEventsStats: (eventIds: string[], c: EventsTableClippingPresentation) =>
      dispatch(createEventsStatisticsRequestedAction(eventIds, c, dispatch)),
    openArchiveEventModal: event => dispatch(createModalOpenAction(SimpleModalId.ArchiveEvent, { event })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventsTableClippingPresentation);
